<template>
  <div>
    <a class="btn btn-primary my-3 ml-3" href="accommodation/new">Add new</a>
    <div class="table-responsive">
      <table class="table table-sm table-nowrap card-table">
        <thead class="text-primary">
          <tr>
            <th>#</th>
            <th>NAME</th>
            <th>Star</th>
            <th>Type</th>
            <th>Comfort Level</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="accom in Accommodation" :key="accom.accomId" :data-id="accom.accomId">
            <td>{{ accom.accomId }}</td>
            <td>{{ accom.accomName }}</td>
            <td class="font-weight-bold">
              {{ accom.rate }}
            </td>
            <td>{{ accom.accomType }}</td>
            <td>{{ accom.accomLevel }}</td>
            <td class="text-right">
              <button @click="edit(accom.accomId)" class="btn btn-sm btn-primary mr-2" :data-id="accom.id">Edit</button>
              <button @click="remove(accom.accomId)" class="btn btn-sm btn-danger ml-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "AccommodationManagement",

  data() {
    return {};
  },

  computed: {
    ...mapGetters(["Accommodation"]),
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchAccommodationAll();
      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions(["hideBarLoading", "fetchAccommodationAll", "deleteAccommodation"]),
    edit(id) {
      window.open("/dashboard/accommodation/edit/" + id, "_blank");
    },
    remove(id) {
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this accommodation?",
        buttons: {
          confirm: async () => {
            await dP.deleteAccommodation(id);
            await this.fetchAccommodationAll();
          },
          cancel: () => {},
        },
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
</style>